import { largestCostChangesWidgetByIdSelector } from "./largestCostChangesWidgetByIdSelector";
import { RootState } from "../../../../store";

export const largestCostChangesWidgetViewIdByWidgetIdSelector = (
  state: RootState,
  widgetId?: string,
): string | undefined => {
  if (!widgetId) {
    return;
  }

  const widget = largestCostChangesWidgetByIdSelector(state, widgetId);

  return widget?.view_id;
};
